// Merge Fields Tour
// Merge fields and custom values for personalized messages
// Selector policy: step 1 pins to the live-verified sidebar id (#sb_settings); teaching steps are
// deliberate centered cards — no guessed element selectors.

export const mergeFieldsTour = {
  id: 'merge-fields',
  name: 'Merge Fields Tour',
  displayName: 'Personalize Everything',
  description: 'Merge fields and custom values for personalized messages',
  estimatedDuration: '3 minutes',
  category: 'feature',
  autoStart: false,
  prerequisiteTours: ['ftux'],

  config: { animate: true, overlayOpacity: 0.75, smoothScroll: true, allowClose: true, showProgress: true },

  steps: [
    {
      element: '#sb_settings',
      popover: {
        title: "🏷️ Welcome to Merge Fields",
        description: `
          Merge fields insert real data into your messages — a name, an appointment time, a balance — so one template speaks to everyone personally.
        `,
        side: 'right',
        align: 'center'
      }
    },

    {
      popover: {
        title: "👤 Contact Merge Fields",
        description: `
          Pull anything from the contact record: first name, company, custom fields, appointment details. The message writes itself around the data you already hold.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🏢 Custom Values",
        description: `
          **Custom values** are account-level constants — your business phone, address, booking link. Reference them everywhere, then change one value and every message updates.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🛟 Always Set a Fallback",
        description: `
          The classic failure is "Hi ," when a first name is missing. Set a **fallback** ("there", "friend") on every personalisation, every time.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🧪 Test With Real Records",
        description: `
          Send a test to a contact with **complete** data and one with **sparse** data. The second test is the one that catches the embarrassing gap.
        `,
        side: 'over',
        align: 'center'
      }
    },

    {
      popover: {
        title: "🎉 Personal At Scale",
        description: `
          You can now:

✅ Insert contact data into any message
✅ Use custom values for account constants
✅ Set fallbacks so nothing reads broken
✅ Test both complete and sparse records

**Next:** audit your most-sent template for missing fallbacks.
        `,
        side: 'over',
        align: 'center',
        showButtons: ['close'],
        doneBtnText: 'Done →'
      }
    }
  ]
};
